import request from '@/router/axios';

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/wage' : '/wage'
// 工资发放批次数据查询
export function titileDetails(obj){
  return request({
    url: urlPrefix+'/payout-batch/getPayBatchPage',
    method: 'post',
    data: obj
  })
}

//发薪明细数据
export function queryPayHistoryPage(obj) {
  return request({
    url: urlPrefix + '/payout-batch-detail/page',
    method: 'post',
    data: obj,
  });
}

export function getDemoPayroll(obj){
  return request({
    url: urlPrefix+'/api/payroll/queryAppPayrollDetail',
    method: 'post',
    data: obj
  })
}
//线下发薪或系统发薪删除
export function deleteByBatchId(obj) {
  return request({
    url: urlPrefix + '/payout-batch-detail/under-delete/'+obj,
    method: 'delete',
    data: obj,
  });
}

//工资发放暂缓发放
export function cachePayAction(obj) {
  return request({
    url: urlPrefix + '/payout-batch-detail/cache-pay-action',
    method: 'post',
    data:obj
  });
}
//线下发薪更新发放状态取消暂缓发放
export function notCachePayAction(obj) {
  return request({
    url: urlPrefix + '/payout-batch-detail/not-cache-pay-action',
    method: 'post',
    data: obj,
  });
}
//工资发放不发
export function notPayAction(obj) {
  return request({
    url: urlPrefix + '/payout-batch-detail/not-pay-action',
    method: 'post',
    data:obj
  });
}
//线下发薪生成支付文件
export function createdPayFile(obj) {
  return request({
    url: urlPrefix + '/bankpay-file/created-payfile',
    method: 'post',
    data: obj,
    responseType: 'arraybuffer',
  });
}

//密码查询
export function queryPwd(obj) {
  return request({
    url: urlPrefix + '/bankpay-file/queryPwd',
    method: 'get',
    data: obj,
  });
}

//查询发放数据
export function getPaybankFileList(obj) {
  return request({
    url: urlPrefix + '/bankpay-file/getPaybankFileList',
    method: 'post',
    data: obj
  });
}

//工资发放确认发放
export function confirmPayAction(obj) {
  return request({
    url: urlPrefix + '/payout-batch-detail/not-confirm-pay-action',
    method: 'post',
    data:obj
  });
}


//获取发放薪资自定义表头
export function findAllPayoutHeaderInfo(param) {
  return request({
    url: urlPrefix + '/payoutheaderinfo/findAll',
    method: 'post',
    data: param
  });
}

//获取发放薪资自定义表头
export function findAllCostFormsHeaderInfo(param) {
  return request({
    url: urlPrefix + '/payoutheaderinfo/findAllCol',
    method: 'post',
    data: param
  });
}


//发薪自定义表头保存调用
export function updataCustHeaderInfo(obj) {
  return request({
    url: urlPrefix + '/payoutheaderinfo/updataCustHeaderInfo',
    method: 'post',
    data: obj
  });
}

export function updataCustCostFormsHeaderInfo(obj) {
  return request({
    url: urlPrefix + '/payoutheaderinfo/updataCustCostFormsHeaderInfo',
    method: 'post',
    data: obj
  });
}

export function costFormsListHeader(obj){
  return request({
    url: urlPrefix + '/payoutheaderinfo/costFormsListHeader',
    method: 'post',
    data: obj
  });
}

//获取薪资明细报表的数据,表头,卡页
export function getPayReportDatas(obj) {
  return request({
    url: urlPrefix + '/salaryHistory/getPayReportDatas',
    method: 'post',
    data: obj
  });
}

//确认发放
export function comfirmPay(obj) {
  return request({
    url: urlPrefix + '/payout-batch-detail/comfirmPay',
    method: 'post',
    data: obj
  });
}

//查询4种薪酬发放状态的数据条数
export function countAllPayNum(obj) {
  return request({
    url: urlPrefix + '/payout-batch-detail/countAllPayNum',
    method: 'post',
    data: obj
  });
}

//更新银行卡信息
export function getBankInfo(obj) {
  return request({
    url: urlPrefix + '/payout-batch/getBankInfo',
    method: 'post',
    data: obj
  });
}

//工资单预览
export function queryPayrollPreView(obj) {
  return request({
    url: urlPrefix + '/api/payroll/queryPayrollPreView',
    method: 'post',
    data: obj,
  });
}
